import { useLocation } from './useLocation';
export function useQueryParams() {
    var location = useLocation();
    return new URLSearchParams(location.search);
}
